import { Component } from '@angular/core';
import { UniTextComponent } from '../uni-text/uni-text.component';

@Component({
  selector: 'uni-text-caption',
  templateUrl: './uni-text-caption.component.html',
  styleUrls: ['./uni-text-caption.component.scss'],
})
export class UniTextCaptionComponent extends UniTextComponent {}
